// SearchBar.js
import React, { useState } from 'react';
import './SearchBar.css'; // Import CSS for styling
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import Typography from '@mui/material/Typography';
import { ListItemIcon, Paper } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import CachedIcon from '@mui/icons-material/Cached';
import ListItemText from '@mui/material/ListItemText';

const SearchBar = ({ onSearch, searchResults, setSearchResults }) => {
    const [searchTerm, setSearchTerm] = useState('');


    const handleInputChange = (event) => {
        if (event.keyCode === 13) { //13 is the key code for Enter
            event.preventDefault()
            return false;
        }
        const query = event.target.value;
        setSearchTerm(query);
        onSearch(query);
    };

    const handleClearClick = () => {
        setSearchTerm('');
        setSearchResults([]);
    };


    return (
        <div className="search-bar">
            <Paper
                component="form"
                sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 250 }}
            >
                <SearchIcon sx={{ fontSize: '20px', color: '#ddd', ml: '2px' }} />
                <InputBase
                    sx={{ ml: 1, flex: 1, color: '#fff' }}
                    placeholder="Search"
                    value={searchTerm}
                    onChange={handleInputChange}
                    onKeyDown={handleInputChange}
                />
                {
                    searchTerm.length && (
                        <IconButton type="button" aria-label="search">
                            <ClearIcon onClick={handleClearClick} sx={{ fontSize: '20px', color: '#ddd', ml: '2px' }} />
                        </IconButton>
                    )
                }

            </Paper>
            {
                searchResults && searchResults.length > 0 && (
                    <div className="search-results">
                        {searchResults.map((result) => (
                            <div key={result.id} className="result-item">
                                <List dense={true} sx={{ width: '100%', maxWidth: 480, bgcolor: 'background.paper' }}>
                                    <ListItem>
                                        <ListItemIcon>
                                            <CachedIcon sx={{ color: '#5F60FF' }} />
                                        </ListItemIcon>
                                        <ListItemText primary={<span style={{ color: '#5F60FF' }}>{result.title}</span>} secondary={result.description} sx={{ width: '200px' }} />
                                        <ListItemText sx={{ ml: 'auto' }} primary={result.id} />
                                    </ListItem>
                                </List>
                            </div>
                        ))}

                    </div>
                )
            }

        </div>
    );
};

export default SearchBar;
